import { PropsWithChildren, createContext, useState } from 'react'

import { DebouncedSearch, useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

export enum AvailabilityFilter {
  available = 'available',
  notAvailable = 'not_available',
  onTrial = 'on_trial',
  comingSoon = 'coming_soon',
}

const ModuleListSearchContext = createContext<{
  search: DebouncedSearch
  availableFilter: AvailabilityFilter | undefined
  setAvailableFilter: (availableFilter: AvailabilityFilter) => void
  availabilityFilterOptions: { label: string; value: AvailabilityFilter }[]
  categoryFilter: string
  setCategoryFilter: (categoryFilter: string) => void
} | null>(null)

export const ModuleListSearchProvider = ({ children }: PropsWithChildren) => {
  const search = useDebouncedSearch()
  const [availableFilter, setAvailableFilter] = useState<AvailabilityFilter>()
  const [categoryFilter, setCategoryFilter] = useState<string>('')

  const availabilityFilterOptions = [
    {
      label: i18n.t('marketplace.modules.filters.availability.installed'),
      value: AvailabilityFilter.available,
    },
    {
      label: i18n.t('marketplace.modules.filters.availability.not_installed'),
      value: AvailabilityFilter.notAvailable,
    },
    {
      label: i18n.t('marketplace.modules.filters.availability.on_trial'),
      value: AvailabilityFilter.onTrial,
    },
    {
      label: i18n.t('marketplace.modules.filters.availability.coming_soon'),
      value: AvailabilityFilter.comingSoon,
    },
  ]

  return (
    <ModuleListSearchContext.Provider
      value={{
        search,
        availableFilter,
        setAvailableFilter,
        availabilityFilterOptions,
        categoryFilter,
        setCategoryFilter,
      }}
    >
      {children}
    </ModuleListSearchContext.Provider>
  )
}
